import "./DataGrid.scss";
import * as React from "react";
import { NoData, NoSearchResults, Checkbox } from "./";
import { DataGridPro as MaterialDataGrid, DataGridProProps as DataGridProps, GridOverlay, GridActionsCellItem, GridRenderCellParams, GridValueFormatterParams, GridEditInputCell } from "@mui/x-data-grid-pro";
import { getDataProps, type WithDataProps } from "../../shared/utilities";
import clsx from "clsx";


const NoDataOverlay = (props: any) => <GridOverlay {...props}><NoData title="No Data" description="No Rows To Show Here" /></GridOverlay>;
const NoSearchResultsOverlay = (props: any) => <GridOverlay {...props}><NoSearchResults title="Not Found" description="No Rows Matching Search Criteria" /></GridOverlay>;
const CheckboxControl = React.forwardRef((props: any, ref) => <Checkbox ref={ref} {...props} color="default" />);


const DataGrid: React.FunctionComponent<WithDataProps<DataGridProps>> = (props: WithDataProps<DataGridProps>) => {
    const { components, className, ...rest } = props;
    const allComponents = {
        NoRowsOverlay: NoDataOverlay,
        NoResultsOverlay: NoSearchResultsOverlay,
        BaseCheckbox: CheckboxControl,
        ...components
    };

    return <div className={clsx("DataGrid-container", className)} {...getDataProps(props)}>
        <MaterialDataGrid
            components={allComponents}
            {...rest}
        />
    </div>
};

export { DataGrid, GridActionsCellItem, GridEditInputCell };
export type { DataGridProps, GridRenderCellParams, GridValueFormatterParams };